import {types} from "../../api";

export default {
    state: {
        all: []
    },

    actions: {
        fetchTypes(context) {
            let token = context.getters.getToken.jwt;
            return types({token}).then(r => {
                context.commit("setTypes", r.data);
            });
        }
    },

    mutations: {
        setTypes(state, payload) {
            console.log(`setTypes payload`, payload);
            state.all = payload;
        }
    },

    getters: {

    }
}